// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyRecommendationsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetRecommendationsRequestWebDto, GetRecommendationsResponseWebDto } from '../..';

export const RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_Path =
  '/api/web/v1/users/properties/recommendations';

/**
 * Get listing recommendations for web clients.
 */
export const RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations = (
  postData: GetRecommendationsRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetRecommendationsRequestWebDto, GetRecommendationsResponseWebDto>(
    {
      endpoint: RentalManagerUserPropertyRecommendationsWebApiHandler_recommendations_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
